<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="commonDialogBox">
      <div class="textContent">
        {{ textContent }}
      </div>
      <div class="bottomBtns">
        <!-- 如果需要展示取消按钮 -->
        <div v-if="showCancelBtn" class="twoBtn">
          <div class="cancelBtn" @click="clickCancel">{{ cancelBtnText }}</div>
          <div class="centerLine"></div>
          <div class="submitBtn" @click="clickSubmit">{{ submitBtnText }}</div>
        </div>
        <!-- 否则只需要展示一个按钮 -->
        <div v-else class="oneBtn">
          <div class="submitBtn" @click="clickSubmit">{{ submitBtnText }}</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: Boolean,
    textContent: String,
    showCancelBtn: {
      type: Boolean,
      value: false,
    },
    submitBtnText: String,
    cancelBtnText: String,
  },
  methods: {
    clickCancel: function () {
      this.$emit("change", false);
    },
    clickSubmit: function () {
      this.$emit("clickSubmit");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./commonDialog.scss";
</style>
